import { render, staticRenderFns } from "./AdminCategory.vue?vue&type=template&id=85a2f99c&scoped=true&"
import script from "./AdminCategory.vue?vue&type=script&lang=ts&"
export * from "./AdminCategory.vue?vue&type=script&lang=ts&"
import style0 from "./AdminCategory.vue?vue&type=style&index=0&id=85a2f99c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a2f99c",
  null
  
)

export default component.exports